document.addEventListener('DOMContentLoaded', function() {
    const navItems = document.querySelectorAll('.home-products__nav');

    navItems.forEach(function(navItem) {
        navItem.addEventListener('click', function() {
            var dataId = this.getAttribute('data-id');
            var targetElement = document.getElementById(dataId);
            
            document.querySelectorAll('.home-products__nav').forEach(function(nav) {
                nav.classList.remove('home-products__nav--current');
            });
            
            document.querySelectorAll('.home-products__slider').forEach(function(slider) {
                slider.classList.remove('home-products__slider--current');   
                slider.style.opacity = '0';
            });

            this.classList.add('home-products__nav--current');
            
            if (targetElement) {
                targetElement.style.opacity = '1';
                targetElement.classList.add('home-products__slider--current');
            }
        });
    });
});